import CartoucheInfos from "./CartoucheInfos";
export default CartoucheInfos;
